import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PaymentService } from '../../../services/payment/payment.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';

@Component({
  selector: 'app-amount-details',
  templateUrl: './amount-details.component.html',
  styleUrls: ['./amount-details.component.scss'],
})
export class AmountDetailsComponent implements OnInit {

  addAmountFormGroup: UntypedFormGroup;
  reasonType: string = '';
  @Output() amount_details_view = new EventEmitter();
  reasons: any;
  alertmsg: boolean = false;
  errorrMsg = 'برجاء إدخال الحقول المطلوبة';
  confirmMsg: string;
  subOrderValue: string = 'المبلغ الطلوب من العميل';
  isAdditionalInvoice: boolean = false;
  saveDialogRef: MatDialogRef<AlertBoxComponent>;
  submitBtn: string = 'التالي';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private paymentService: PaymentService,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) {}
  
  ngOnInit(): void {
    this.createForm();
    this.createFormControls();
    if(this.route.snapshot.queryParams.additionaInvoice == 'true') {
      this.isAdditionalInvoice = true;
      this.submitBtn = 'إضافة';
      this.getadditionalInvoiceReasons();
    } else {
      this.getReasons();
    }
  }
  
  createFormControls() {
    return this.addAmountFormGroup.controls;
  }
 
  createForm() {
    this.addAmountFormGroup = this.formBuilder.group({
      reference_number: [null, Validators.required],
      reason_pk: [null, Validators.required],
      sub_order_value: [null, Validators.required],
      sub_order_inspector_share_amount: [0],
      notes: [''],
    });
  }
  
  patchAddAmountForm() {
    let formValues = JSON.parse(localStorage.getItem('additional_amount'));
    this.addAmountFormGroup.patchValue({
      reference_number: formValues.reference_number,
      reason_pk: formValues.reason_pk,
      sub_order_value: formValues.sub_order_value,
      sub_order_inspector_share_amount: formValues.sub_order_inspector_share_amount,
      notes: formValues.notes
    });
    this.checkType(formValues.reason_pk);
  }

  getReasons() {
    this.paymentService.getOrderReasons().subscribe(
      (data) => {
        this.reasons = data;
        if (localStorage.getItem('additional_amount'))
          this.patchAddAmountForm();
      },
      (error) => {
        try {
          console.log(error);
        } catch {
          console.log(error);
        }
      }
    );
  }

  getadditionalInvoiceReasons () {
    this.paymentService.getAdditionalInvoiceReasons().subscribe(
      reasonses => {
        this.reasons = reasonses;
        if (localStorage.getItem('additional_amount')) {
          this.patchAddAmountForm();
        }
      }, (error) => {
        try {
          console.log(error);
        } catch {
          console.log(error);
        }
      }
    )
  }

  checkType(event) {
    for (let reason of this.reasons) {
      if (reason.pk == event) {
        this.reasonType = reason.reason_type;
        switch (this.reasonType) {
          case 'ADD':
            this.subOrderValue = 'مبلغ إضافى للفاحص';
            break;
          case 'DEDUCT':
            this.subOrderValue = 'مبلغ خصم للفاحص';
            break;
          default:
            this.subOrderValue = 'المبلغ الطلوب من العميل';
        }
      }
    }
    this.setFormValidation();
  }
  
  save() {
    if (this.addAmountFormGroup.status == 'INVALID') {
      this.alertmsg = true;
      let fields = document.querySelectorAll(
        'ng-select.ng-invalid , input.ng-invalid '
      );
      fields.forEach((field) => {
        field.parentElement.classList.add('invalid-field');
      });
      return;
    }

    let formData = this.addAmountFormGroup.value;
    if(this.isAdditionalInvoice) {
      this.saveAdditionalInvoice(formData);
    } else {
      this.saveSubOrder(formData);
    }
    
  }

  setFormValidation() {
    if(this.reasonType === 'EAT') {
      this.addAmountFormGroup.controls['sub_order_inspector_share_amount'].setValidators(Validators.required);
      this.addAmountFormGroup.controls['sub_order_inspector_share_amount'].updateValueAndValidity();
    } else {
      this.addAmountFormGroup.controls['sub_order_inspector_share_amount'].setValue(null);
      this.addAmountFormGroup.controls['sub_order_inspector_share_amount'].clearValidators();
      this.addAmountFormGroup.controls['sub_order_inspector_share_amount'].updateValueAndValidity();
    }
  }

  saveSubOrder(formData) {
    this.paymentService.calcSubOrderAmount(formData).subscribe(
      (data) => {
        this.goSummary(data, formData);
      }, (error) => {
        this.handleServerError(error);
      }
    );
  }

  saveAdditionalInvoice(formData) {
    const data = {
      reference_number: formData.reference_number,
      amount: formData.sub_order_value,
      reason: formData.reason_pk,
      notes: formData.notes
    };
    this.paymentService.addAdditionalInvoice(data).subscribe(
      data => {
        this.showAlertBox();
      }, (error) => {
        this.handleServerError(error);
      }
    )
  }

  goSummary(data, formData) {
    this.amount_details_view.emit({ viewName: 'summary', data: data });
    localStorage.setItem('additional_amount', JSON.stringify(formData));
  }

  showAlertBox() {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: true,
        message: 'تم إضافة المعاملة المالية',
        button: 'تم',
        backUrl: '/pages/orders/orders-list',
      },
    });
  }

  handleServerError(error) {
    this.alertmsg = true;
    this.errorrMsg = Object.values(error.error)[0].toString();
  }

  hideErrorMsg() {
    this.alertmsg = false;
  }
}
